// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cbadf16a","453":"c09500c1"}[chunkId] + ".chunk.js";
};